import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { catchError, map, switchMap } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { KwikspaceService } from 'src/app/services/kwikspace.service';
import { CreateRentalLineItemFailure, CreateRentalLineItemSuccess, GetRentalListFailure, GetRentalListSuccess, GetRentalCategoryFailure, GetRentalCategorySuccess, GetRentalOptionFailure, GetRentalOptionSuccess, GetRentalPeriodFailure, GetRentalPeriodSuccess, GetRentalPriceFailure, GetRentalPriceSuccess, GetRentalSizeFailure, GetRentalSizeSuccess, RentalActionTypes, UpdateRentalLineItemFailure, UpdateRentalLineItemSuccess, GetRentalCategorySizeSuccess, GetRentalCategorySizeFailure } from "../actions/rental.action";

@Injectable()
export class RentalEffects {
  public constructor(
    private actions$: Actions,
    private service: KwikspaceService
  ) { }

  @Effect()
  GetRentalChargeList$: Observable<any> = this.actions$.pipe(
    ofType(RentalActionTypes.GET_RENTAL_PRICE_LIST),
    switchMap((action: any) => {
      return this.service.getRentalPricingList(action.payload).pipe(
        map((res: any) => new GetRentalListSuccess(res)),
        catchError((error) => of(new GetRentalListFailure(error)))
      );
    })
  );

  @Effect()
  GetRentalPricing$: Observable<any> = this.actions$.pipe(
    ofType(RentalActionTypes.GET_RENTAL_PRICE),
    switchMap((action: any) => {
      return this.service.getRentalPricing(action.payload).pipe(
        map((res: any) => new GetRentalPriceSuccess(res)),
        catchError((error) => of(new GetRentalPriceFailure(error)))
      );
    })
  );

  @Effect()
  GetRentalSize$: Observable<any> = this.actions$.pipe(
    ofType(RentalActionTypes.GET_RENTAL_SIZE),
    switchMap((action: any) => {
      return this.service.getRentalSizes().pipe(
        map((res: any) => new GetRentalSizeSuccess(res)),
        catchError((error) => of(new GetRentalSizeFailure(error)))
      );
    })
  );

  @Effect()
  GetRentalPeriod$: Observable<any> = this.actions$.pipe(
    ofType(RentalActionTypes.GET_RENTAL_PERIOD),
    switchMap((action: any) => {
      return this.service.getRentalPeriods().pipe(
        map((res: any) => new GetRentalPeriodSuccess(res)),
        catchError((error) => of(new GetRentalPeriodFailure(error)))
      );
    })
  );

  @Effect()
  GetRentalOption$: Observable<any> = this.actions$.pipe(
    ofType(RentalActionTypes.GET_RENTAL_OPTION),
    switchMap((action: any) => {
      return this.service.getRentalOptions().pipe(
        map((res: any) => new GetRentalOptionSuccess(res)),
        catchError((error) => of(new GetRentalOptionFailure(error)))
      );
    })
  );
  
  @Effect()
  GetRentalCategory$: Observable<any> = this.actions$.pipe(
    ofType(RentalActionTypes.GET_RENTAL_CATEGORY),
    switchMap((action: any) => {
      return this.service.getRentalCategory().pipe(
        map((res: any) => new GetRentalCategorySuccess(res)),
        catchError((error) => of(new GetRentalCategoryFailure(error)))
      );
    })
  );
  
  @Effect()
  GetRentalCategorySize$: Observable<any> = this.actions$.pipe(
    ofType(RentalActionTypes.GET_RENTAL_CATEGORY_SIZE),
    switchMap((action: any) => {
      return this.service.getRentalCategorySize(action.payload).pipe(
        map((res: any) => new GetRentalCategorySizeSuccess(res)),
        catchError((error) => of(new GetRentalCategorySizeFailure(error)))
      );
    })
  );

  @Effect()
  CreateRentalLineItem$: Observable<any> = this.actions$.pipe(
    ofType(RentalActionTypes.CREATE_RENTAL_LINE_ITEM),
    switchMap((action: any) => {
      return this.service.createRentalLineItems(action.payload).pipe(
        map((res: any) => new CreateRentalLineItemSuccess(res)),
        catchError((error) => of(new CreateRentalLineItemFailure(error)))
      );
    })
  );

  @Effect()
  UpdateRentalLineItem$: Observable<any> = this.actions$.pipe(
    ofType(RentalActionTypes.UPDATE_RENTAL_LINE_ITEM),
    switchMap((action: any) => {
      return this.service.updateRentalLineItem(action.payload, action.id).pipe(
        map((res: any) => new UpdateRentalLineItemSuccess(res)),
        catchError((error) => of(new UpdateRentalLineItemFailure(error)))
      );
    })
  );
}
